import { useSnackbar } from 'notistack'
import { t } from '@lingui/macro'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import TopbarButton from '@/layouts/diagnostic/TopbarButton'
import { Tooltip } from '@mui/material'

export function CopyLinkButton({ expertiseMeetingId }: { expertiseMeetingId: string }) {
  const { enqueueSnackbar } = useSnackbar()
  return (
    <Tooltip title={t`Copy link`}>
      <TopbarButton
        onClick={() => {
          navigator.clipboard.writeText(`${window.location.origin}/expertise-meetings/${expertiseMeetingId}`)
          enqueueSnackbar(t`Expertise meeting link copied`, { variant: 'success' })
        }}
      >
        <ContentCopyIcon htmlColor="white" />
      </TopbarButton>
    </Tooltip>
  )
}
